/**
 * Sample to Chunk Entry
 *
 * @group ISOBMFF
 *
 * @beta
 */
export type SampleToChunkEntry = {
	firstChunk: number;
	samplesPerChunk: number;
	sampleDescriptionIndex: number;
};
